import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FaVideo } from "react-icons/fa";
import dataJson from "../assets/json/datos.json";
import fondoDefault from "../assets/img/fondoOferta.webp";
import NotFound from "../components/404";

// ICONOS 🚀
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaBook,
  FaLaptop,
  FaClipboardList,
  FaBookOpen,
} from "react-icons/fa";

// FONDOS
import fondo1 from "../assets/img/fondoOferta.webp";

const fondos = {
  "fondoOferta.webp": fondo1,
};

export default function ServiciosVirtuales() {
  const { sede, tipo } = useParams();

  const [fondoImg, setFondoImg] = useState(fondoDefault);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Buscar la info de la sede en el JSON
  const sedeKey = sede
    ? Object.keys(dataJson).find(
        (key) => key.toLowerCase() === sede.toLowerCase(),
      )
    : null;
  const sedeInfo = sedeKey ? dataJson[sedeKey] : null;

  // Si la sede tiene su propia plataforma en el JSON la usa; si no, va a la central por defecto
  const urlPlataforma =
    sedeInfo?.plataformaVirtual || "https://virtual.uno.edu.bo/login/index.php";

  // Efecto para fondo dinámico
  useEffect(() => {
    if (sedeInfo?.imagenes?.fondoPrincipal) {
      const fondo = fondos[sedeInfo.imagenes.fondoPrincipal];
      setFondoImg(fondo || fondoDefault);
    }
  }, [sedeInfo]);

  const serviciosBase = [
    {
      titulo: "SERVICIO_DINAMICO",
      icono: <FaClipboardList size={60} />,
      link: "LINK_DINAMICO",
    },
    {
      titulo: "Plataforma Virtual",
      icono: <FaLaptop size={60} />,
      link: urlPlataforma,
    },
    {
      titulo: "Biblioteca Virtual Digitalia",
      icono: <FaBook size={60} />,
      link: "https://www.digitaliapublishing.com/",
    },
    {
      titulo: "Biblioteca Virtual EBSCO",
      icono: <FaBook size={60} />,
      link: "https://search.ebscohost.com",
    },
    {
      titulo: "Biblioteca Universitaria",
      icono: <FaBookOpen size={60} />,
      link: "http://89.117.149.22:8080/#/",
    },
  ];

  let servicios = [...serviciosBase];
  let titulo = "";

  // dinámico según tipo
  if (tipo === "estudiante") {
    servicios[0] = {
      titulo: "Consulta Tus Notas",
      icono: <FaUserGraduate size={60} />,
      link: "https://alumno.uno.edu.bo/",
    };

    servicios.splice(2, 0, {
      titulo: "Tutoriales Alumnos",
      icono: <FaVideo size={60} />,
      link: "https://drive.google.com/drive/folders/1dvGgQCRPBIbKkO_9ABrrmjl22Y_d2W7V",
    });

    titulo = "Servicios para Estudiantes";
  } else if (tipo === "docente") {
    servicios[0] = {
      titulo: "Sistema Docente UNO",
      icono: <FaChalkboardTeacher size={60} />,
      link: "https://sistema2.uno.edu.bo/",
    };
    servicios.splice(2, 0, {
      titulo: "Tutoriales Docentes",
      icono: <FaVideo size={60} />,
      link: "https://drive.google.com/drive/folders/1dvGgQCRPBIbKkO_9ABrrmjl22Y_d2W7V",
    });
    titulo = "Servicios para Docentes";
  } else {
    return <NotFound mensaje="Ruta no válida" />;
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
    hover: {
      scale: 1.05,
    },
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${fondoImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        marginTop: "-14rem",
        position: "relative",
      }}
    >
      {/* capa blanca */}
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.85)",
        }}
      />

      {/* contenido */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "1100px",
          margin: "auto",
          padding: "2rem",
          marginTop: "6rem",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "3rem",
            fontWeight: "700",
            marginBottom: "3rem",
            marginTop: "6rem",
            color: "#001A66",
          }}
        >
          {titulo}
        </h1>

        {/* grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 220px)",
            justifyContent: "center",
            gap: "2rem",
          }}
        >
          {servicios.map((servicio, index) => (
            <motion.a
              key={index}
              href={servicio.link}
              target="_blank"
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              whileHover="hover"
              style={{
                background: "#fff",
                padding: "1.5rem",
                borderRadius: "10px",
                textAlign: "center",
                textDecoration: "none",
                color: "#001A66",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              {/* ICONO */}
              <div style={{ marginBottom: "1rem" }}>{servicio.icono}</div>

              <h4>{servicio.titulo}</h4>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
}
